/**
 * @generated SignedSource<<07ae30946940cca58bd53507a76b1a8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PublishingStatus = "acknowledged" | "failed" | "inprogress" | "succeeded";
import { FragmentRefs } from "relay-runtime";
export type educationalOfferTree_PublishingV2Fragment$data = {
  readonly status: PublishingStatus;
  readonly " $fragmentSpreads": FragmentRefs<"publishingFailedNotice_PublishingV2Fragment">;
  readonly " $fragmentType": "educationalOfferTree_PublishingV2Fragment";
};
export type educationalOfferTree_PublishingV2Fragment$key = {
  readonly " $data"?: educationalOfferTree_PublishingV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"educationalOfferTree_PublishingV2Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "educationalOfferTree_PublishingV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "publishingFailedNotice_PublishingV2Fragment"
    }
  ],
  "type": "PublishingV2",
  "abstractKey": null
};

(node as any).hash = "23335ca289e0c14bec30ef1f1b664fc7";

export default node;
